// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__1J6Wf","additionalInfo":"AgreementModal_additionalInfo__1vSnS"};